export default __webpack_public_path__ + "static/media/clapping_hands.a6d698ef.svg";